import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";

const data = [
  {
    key: "1",
    incidentID: "C001",
    caseHistory: "Incident occurred on 2024-06-20, last update 2024-07-10",
    legalResearch: "Notes on relevant privacy laws, case studies",
    relatedCases: "C001",
  },
  {
    key: "2",
    incidentID: "C001",
    caseHistory: "Incident filed on 2023-08-15, final update 2024-01-10",
    legalResearch: "Research on intellectual property rights",
    relatedCases: "C002",
  },
];
const IncidentTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const columns = [
    {
      title: t("dashboard.incidentDetails.incidentID"),
      dataIndex: "incidentID",
      key: "incidentID",
      render: (text) => <p className="text-darkGrey small font-poppins">{text}</p>,
    },
    {
      title: t("dashboard.incidentDetails.caseHistory"),
      dataIndex: "caseHistory",
      key: "caseHistory",
      render: (history) => <p className="text-darkGrey small font-poppins">{history}</p>,
    },
    {
      title: t("dashboard.incidentDetails.legalResearch"),
      dataIndex: "legalResearch",
      key: "legalResearch",
      render: (research) => <p className="text-darkGrey small font-poppins">{research}</p>,
    },
    {
      title: t("dashboard.incidentDetails.relatedCases"),
      dataIndex: "relatedCases",
      key: "relatedCases",
      render: (relatedCases) => <p className="text-darkGrey small font-poppins">{relatedCases}</p>,
    },
    {
      title: t("dashboard.incidentDetails.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => {
              navigate("/incident/incident-details");
            }}
          >
            {t("dashboard.incidentDetails.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      {" "}
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
    </>
  );
};

export default IncidentTable;
